export default __webpack_public_path__ + "static/joySCA-4541df3981783c02f52ec72160fa1c07.webp";